import { assertQuickActionItems, assertQuickActionListener } from "./validate";
function setItems(items) {
  assertQuickActionItems(items);
  return Promise.resolve();
}
function getItems() {
  return Promise.resolve([]);
}
function getInitialAction() {
  return null;
}
function clearInitialAction() {
  return void 0;
}
function addListener(listener) {
  assertQuickActionListener(listener);
  return function() {
  };
}
var QuickActions = Object.freeze({
  setItems,
  getItems,
  getInitialAction,
  clearInitialAction,
  addListener
});
export {
  QuickActions
};
//# sourceMappingURL=unavailable.js.map
